import { Typography } from "@mui/material";
import { ReactNode } from "react";

/** Two cards stand side by side where each is at least this wide, in px. */
const CARD_MIN_WIDTH = 380;

/** A card of a page of the portfolio. */
export const card = { borderRadius: 3, px: 2.5, pt: 2, pb: 2.25 } as const;

/** Cards side by side where each has its room, one under another where not. */
export const cardRow = {
  display: "grid",
  gridTemplateColumns: `repeat(auto-fit, minmax(min(${CARD_MIN_WIDTH}px, 100%), 1fr))`,
  gap: 2.25,
} as const;

/**
 * The heading a section of a page of the portfolio starts with; the navigation
 * scrolls to it by its id. A rule sets the section off from the one above it.
 */
export const SectionHeading = ({
  id,
  rule = false,
  children,
}: {
  id: string;
  rule?: boolean;
  children: ReactNode;
}) => (
  <Typography
    id={id}
    variant="h6"
    component="h2"
    sx={{
      mt: 1,
      fontWeight: 700,
      letterSpacing: "-.005em",
      ...(rule && { pt: 2.75, borderTop: 1, borderColor: "divider" }),
    }}
  >
    {children}
  </Typography>
);
